import React from 'react';
import MessageRight from '../../MessageRight';

const SectionOne = () => {
    return (
        <section className="property-details property-details-one" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="col-lg-8 col-md-12 col-sm-12 content-side">
                        <div className="blog-details-content">
                            <div className="news-block-one">
                                <div className="inner-box">
                                    <div className="lower-content">
                                        <h3 style={{ fontSize: '36px', marginBottom: '20px' }}>I am a Landlord</h3>
                                        <div className="text" style={{ fontSize: '18px', lineHeight: '1.8' }}>
                                            <p>Our tailored landlord services are designed to give you peace of mind and maximize your returns. We offer a full range of services, including:</p>
                                            <ul style={{ listStyleType: 'none', paddingLeft: '0', marginTop: '20px', marginBottom: '30px' }}>
                                                <li style={{ marginBottom: '15px' }}><i className="fas fa-check-circle" style={{ color: '#25b579', marginRight: '10px' }}></i> Comprehensive property marketing</li>
                                                <li style={{ marginBottom: '15px' }}><i className="fas fa-check-circle" style={{ color: '#25b579', marginRight: '10px' }}></i> Strict tenant screening and referencing</li>
                                                <li style={{ marginBottom: '15px' }}><i className="fas fa-check-circle" style={{ color: '#25b579', marginRight: '10px' }}></i> Drafting tenancy agreements</li>
                                                <li style={{ marginBottom: '15px' }}><i className="fas fa-check-circle" style={{ color: '#25b579', marginRight: '10px' }}></i> Rent collection and arrears management</li>
                                                <li style={{ marginBottom: '15px' }}><i className="fas fa-check-circle" style={{ color: '#25b579', marginRight: '10px' }}></i> Regular property inspections</li>
                                                <li style={{ marginBottom: '15px' }}><i className="fas fa-check-circle" style={{ color: '#25b579', marginRight: '10px' }}></i> Dedicated property maintenance support</li>
                                            </ul>
                                            <p>Contact us today for a free evaluation of your property and learn how we can help you get the most out of your investment.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 sidebar-side">
                        <div className="property-sidebar default-sidebar">
                            <div className="author-widget sidebar-widget">
                                <div className="author-box">
                                    <figure className="author-thumb">
                                        <img src="assets/images/resource/test-1.jpg" alt="Manav Seth" />
                                    </figure>
                                    <div className="inner">
                                        <h4>Manav Seth</h4>
                                        <ul className="info clearfix">
                                            <li>
                                                <i className="fas fa-phone" />
                                                <a href="tel:07985 193841">07985 193841</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="form-inner">
                                    <MessageRight />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SectionOne;
